module.exports = __webpack_public_path__ + "img/r1.f08c9617.png";